import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MATCHDAY_MODULE_TYPE } from '../modules/matchday/constants/identifiers';
import { calculateTimeDifference, formatTimeInSeconds, formatTimeToHHMM } from '../../../helpers/helperFunctions';
import { getText } from '../../../helpers/localization';
import style from '../css/preambleTextBasedMatchday.css';
import { ASSETS_URL } from '../../../constants/endpoints';
import { eventLiveTextBasedCounter } from './eventLiveCounter';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        serverTimeOffset: state.vpp.serverTimeOffset,
    };
};

class PreambleTextBasedMatchday extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.state = {
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            timeLeft: this._getTimeLeft(),
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
        };
    }

    _getTimeLeft() {
        let eventTime = this._getEventTime();
        if (eventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), eventTime) / 1000;
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    _getEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.events !== undefined && Array.isArray(this.state.events[this.state.selectedEventIndex])) {
            event = this.state.events[this.state.selectedEventIndex].find((event) => event.channel === this.state.games[this.state.selectedGameIndex].channel 
                            && Number(event.eventTimeDate) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTimeDate);
            }
        }
        return eventTime;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                events: storeData.vpp.events,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset
            });
        }
    }

    findKit(awayKitId, length) {
        let id = '' + awayKitId;
        while (id.length < length) {
            id = '0' + id;
        }
        return id;
    }

    render() {
        if (this.state.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE) {
            let matchdayEvents = this.state.events[this.state.selectedEventIndex];

            if (matchdayEvents !== undefined && Array.isArray(matchdayEvents)) {
                let homeTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";
                let awayTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";

                let teamBoard = matchdayEvents.map((event, index) => {
                    return (<div className={style.eventContainer} key={index}>
                        <div className={style.team}>
                            <div className={style.silkContainerLeft}>
                                <img className={style.image}
                                    src={homeTeamSilk + this.findKit(event.homeKitId, 4) + ".png"} />
                            </div>
                            <div className={style.teamNameLeft}>
                                <b>
                                    {getText('Matchday_' + event.teamOne, this.props.store)}
                                </b>
                            </div>
                        </div>
                        <div className={style.eventTime}>
                            {formatTimeToHHMM(event.eventTime)}
                        </div>
                        <div className={style.team}>
                            <div className={style.teamNameRight}>
                                <b>
                                    {getText('Matchday_' + event.teamTwo, this.props.store)}
                                </b>
                            </div>
                            <div className={style.silkContainerRight}>
                                <img className={style.image}
                                    src={awayTeamSilk + this.findKit(event.awayKitId, 4) + ".png"} />
                            </div>
                        </div>
                    </div>);
                });

                let timer = (<div className={this.state.timeLeft === undefined ? 
                                    style.hideRightContainer : style.rightContainer}> 
                                {eventLiveTextBasedCounter(formatTimeInSeconds(this.state.timeLeft))}
                            </div>);

                return (
                    <div className={style.outerContainer}>
                        <div className={style.betTitle}>{getText('Next Fixtures', this.props.store)}</div>
                        <div className={style.mainContainer}>
                            {teamBoard}
                        </div>
                        {timer}
                    </div>
                );
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

export default connect(mapStateToProps)(PreambleTextBasedMatchday);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/preambleTextBasedMatchday.js